export var OTTemperaturePreference;
(function (OTTemperaturePreference) {
    OTTemperaturePreference["WATER"] = "WATER";
    OTTemperaturePreference["DHW"] = "DHW";
})(OTTemperaturePreference || (OTTemperaturePreference = {}));
export var SensorState;
(function (SensorState) {
    SensorState[SensorState["OFFLINE"] = 0] = "OFFLINE";
    SensorState[SensorState["OUT_OF_UPPER_THRESHOLD"] = 1] = "OUT_OF_UPPER_THRESHOLD";
    SensorState[SensorState["OUT_OF_LOWER_THRESHOLD"] = 2] = "OUT_OF_LOWER_THRESHOLD";
    SensorState[SensorState["ACTUATION"] = 3] = "ACTUATION";
    SensorState[SensorState["RECOVERY"] = 4] = "RECOVERY";
    SensorState[SensorState["OUT_OF_UPPER_HUMIDITY_THRESHOLD"] = 5] = "OUT_OF_UPPER_HUMIDITY_THRESHOLD";
    SensorState[SensorState["OUT_OF_LOWER_HUMIDITY_THRESHOLD"] = 6] = "OUT_OF_LOWER_HUMIDITY_THRESHOLD";
})(SensorState || (SensorState = {}));
